import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator,
  RefreshControl,
} from 'react-native';
import {
  Button,
} from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { SectionGrid } from 'react-native-super-grid';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import { translate } from '../../../locales/i18n';
import AORTypes from '../../../types';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import GetMyApps from '../../../q/create/GetMyApps';
import GetMyPublishedApps from '../../../q/GetMyPublishedApps';
import MyAppBadge from '../../../components/apps/MyAppBadge';
import AppBadge from '../../../components/apps/AppBadge';
import App from '../../../modules/data/App';

const STATUS_INCOMPLETE = 0;
const STATUS_IN_REVIEW = 1;
const STATUS_PUBLISHED = 2;
const STATUS_DEPRECATED = 3;

class PublisherApps extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherApps';

    this.handleRefresh = this.handleRefresh.bind(this);

    this.state = {
      refreshing: false,
    };
  }

  handleRefresh() {
    const { onRefresh1, onRefresh2 } = this.props;
    this.setState({ refreshing: true });

    Promise.all([onRefresh1(), onRefresh2()])
      .then(() => {
        this.setState({ refreshing: false });
      });
  }

  render() {
    const {
      history,
      loading,
      loading2,
      appsIncomplete,
      appsInReviewFiltered,
      appsPublished,
      appsDeprecated,
      user,
      onRefresh1,
    } = this.props;
    const {
      refreshing,
    } = this.state;

    if (!user) {
      return (
        <>
        </>
      );
    }

    if (loading && loading2
      && appsIncomplete.length === 0
      && appsInReviewFiltered.length === 0
      && appsPublished.length === 0
      && appsDeprecated.length === 0) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          <Button
            title={translate('publisher_apps_token')}
            containerStyle={{
              ...ifIphoneX({
                alignSelf: 'center',
                paddingTop: 38,
              }, {
                alignSelf: 'flex-end',
                paddingTop: 8,
                // paddingRight: 12,
              }),
            }}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={() => {
              if (user && user.username) {
                history.push('/token');
              } else {
                history.push('/signin/token');
              }
            }}
          />
          <Button
            title={translate('publisher_apps_add')}
            disabled
            containerStyle={{
              ...ifIphoneX({
                alignSelf: 'center',
                paddingTop: 38,
              }, {
                alignSelf: 'flex-end',
                paddingTop: 8,
                paddingRight: 12,
              }),
            }}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => {
              if (user && user.username) {
                history.push('/addapp');
              } else {
                history.push('/signin/addapp');
              }
            }}
          />
        </View>

        {(appsIncomplete.length === 0
          && appsInReviewFiltered.length === 0
          && appsPublished.length === 0
          && appsDeprecated.length === 0)
          ? (
            <View
              style={{ margin: 10, marginTop: 30, alignItems: 'center' }}
            >
              <Text
                style={{
                  fontSize: 20,
                }}
              >
                {translate('publisher_apps_none')}
              </Text>
            </View>
          ) : (
            <SectionGrid
              // TODO(clairbee): make the price line non-wrapping and, then, reduce 'itemDimension'
              itemDimension={310} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
              itemContainerStyle={{
                paddingBottom: 30,
              }}
              sections={[
                ...(appsIncomplete.length > 0
                  ? [{
                    title: translate('publisher_apps_incomplete'),
                    data: appsIncomplete,
                    status: STATUS_INCOMPLETE,
                  }]
                  : []
                ),
                ...(appsInReviewFiltered.length > 0
                  ? [{
                    title: translate('publisher_apps_inreview'),
                    data: appsInReviewFiltered,
                    status: STATUS_IN_REVIEW,
                  }]
                  : []
                ),
                ...(appsPublished.length > 0
                  ? [{
                    title: translate('publisher_apps_published'),
                    data: appsPublished,
                    status: STATUS_PUBLISHED,
                  }]
                  : []
                ),
                ...(appsDeprecated.length > 0
                  ? [{
                    title: translate('publisher_apps_deprecated'),
                    data: appsDeprecated,
                    status: STATUS_DEPRECATED,
                  }]
                  : []
                ),
              ]}
              renderItem={
                ({ item, section }) => (item.status === STATUS_DEPRECATED ? (
                  <MyAppBadge
                    data={App.createFromData(item.app).data}
                    stats={item.app.stats}
                  />
                ) : (
                  <TouchableOpacity
                    key={item.uuid}
                    onPress={() => {
                      if (section.status === STATUS_PUBLISHED) {
                        history.push(`/approved/${item.uuid}`);
                      } else if (section.status === STATUS_IN_REVIEW) {
                        history.push(`/ai-agent/${App.createFromData(item.app).data.pending}`);
                      } else {
                        history.push(`/editapp/${item.uuid}`);
                      }
                    }}
                  >
                    <AppBadge
                      data={section.status === STATUS_PUBLISHED ? App.createFromData(item.app).data : item.app}
                      stats={section.status === STATUS_PUBLISHED ? item.app.stats : undefined}
                    />
                  </TouchableOpacity>
                ))
              }
              renderSectionHeader={
                ({ section }) => (
                  <Text style={stylesPublisher.publisherApps.section}>
                    {section.title}
                  </Text>
                )
              }
              refreshControl={onRefresh1 !== undefined ? (
                <RefreshControl
                  refreshing={refreshing}
                  onRefresh={this.handleRefresh}
                />
              ) : undefined}
            />
          )}
      </View>
    );
  }
}

PublisherApps.defaultProps = {
  user: null,
  loading2: false,
  appsInReviewFiltered: [],
  appsPublished: [],
  appsDeprecated: [],
};

PublisherApps.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
  loading: PropTypes.bool.isRequired,
  loading2: PropTypes.bool,
  appsIncomplete: PropTypes.arrayOf(AORTypes.MyApp).isRequired,
  appsInReviewFiltered: PropTypes.arrayOf(AORTypes.MyApp),
  appsPublished: PropTypes.arrayOf(AORTypes.MyApp),
  appsDeprecated: PropTypes.arrayOf(AORTypes.MyApp),
  onRefresh1: PropTypes.func.isRequired,
  onRefresh2: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetMyApps, {
    props: (props) => {
      console.log('graphql returned: GetMyApps: ');
      console.log(props.data);
      return {
        onRefresh1: props.data.refetch,
        loading: props.data.loading,
        appsIncomplete:
          props.data.queryMyApps && props.data.queryMyApps.items
            ? props.data.queryMyApps.items.filter((item) => item.app && !item.app.completed)
            : [],
        appsInReview:
          props.data.queryMyApps && props.data.queryMyApps.items
            ? props.data.queryMyApps.items.filter((item) => item.app && item.app.completed)
            : [],
      };
    },
    options: (props) => ({
      client: AppSyncClientCreate(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientCreate,
  }),
  graphql(GetMyPublishedApps, {
    // skip: (props) => !props.appsInReview || props.appsInReview.length === 0,
    props: (props) => {
      console.log('graphql returned: GetMyPublishedApps: ');
      console.log(props);
      console.log(props.data);

      const origins = {};
      if (props.data.queryMyPublishedApps && props.data.queryMyPublishedApps.items) {
        props.data.queryMyPublishedApps.items.forEach((published) => {
          const data = JSON.parse(published.app.data);
          origins[data.origin] = true;
        });
      }

      return {
        onRefresh2: props.data.refetch,
        loading2: props.data.loading,
        appsInReviewFiltered:
          props.ownProps.appsInReview && props.ownProps.appsInReview.length > 0
            ? props.ownProps.appsInReview.filter((item) => !(item.app.completed && origins[item.uuid]))
            : [],
        appsPublished:
          props.data.queryMyPublishedApps && props.data.queryMyPublishedApps.items
            ? props.data.queryMyPublishedApps.items.filter((item) => item.app.coords10 !== null).sort((a, b) => a.app.publishedAt > b.app.publishedAt)
            : [],
        appsDeprecated:
          props.data.queryMyPublishedApps && props.data.queryMyPublishedApps.items
            ? props.data.queryMyPublishedApps.items.filter((item) => item.app.coords10 === null).sort((a, b) => a.app.publishedAt > b.app.publishedAt)
            : [],
      };
    },
    options: (props) => ({
      client: AppSyncClientCreate(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientCreate,
  })
)(PublisherApps);
